<aside class="sidebar-shell-wrapper aic-interior-sidebar bg-white border-end d-flex flex-column justify-content-between position-relative overflow-hidden flex-shrink-0 w-100">

  <!-- Brand header -->
  <div class="sidebar-header d-flex align-items-center gap-3">
    <SidebarBrand
      :logo="logo"
      :title="brand_title"
      :subtitle="brand_subtitle"
      @brand-click="$emit('brand-click')"
    />

    <!-- Mobile close action -->
    <slot name="sidebar-header-actions"></slot>
  </div>

  <hr class="border-warning opacity-25 my-2">

  <!-- Scroll area -->
  <div class="sidebar-scroll-area flex-grow-1 overflow-auto overflow-x-hidden">

    <!-- Context block -->
    <slot name="context"></slot>

    <hr class="border-warning opacity-25 my-2">

    <!-- Menu block -->
    <slot name="menu"></slot>

    <!-- After-menu block -->
    <slot name="after-menu"></slot>

  </div>

  <!-- User footer -->
  <SidebarUserFooter
    :initials="initials"
    :full_name="full_name"
    :is_admin="is_admin"
  />

</aside>
